import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseChart = _resolveComponent("BaseChart")!

  return (_openBlock(), _createBlock(_component_BaseChart, {
    chartData: _ctx.series,
    chartOptions: _ctx.chartOptions
  }, null, 8, ["chartData", "chartOptions"]))
}